import { OverlayScrollbars } from 'overlayscrollbars';
import 'overlayscrollbars/overlayscrollbars.css';
import './overlayscrollbars.scss';

export const initScrollbar = () => {
    $('.js-scrollbar').map((index, item) => {
        OverlayScrollbars(item, {});
    });
};

initScrollbar();
